module.exports = __webpack_public_path__ + "static/media/Cribis.cz_white.5b4ff9bf.svg";